import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type OrganizationAdminsPathRequestParams = paths['/v3/organizations/{id}/admins']['get']['parameters']['path'];
type OrganizationAdminsQueryRequestParams = paths['/v3/organizations/{id}/admins']['get']['parameters']['query'];
type ResponseType = paths['/v3/organizations/{id}/admins']['get']['responses']['200']['content']['application/json'];

export const getOrganizationAdmins = async ({
  config: { params },
  routeParams: { id },
}: ConfigRouteParamsRequest<OrganizationAdminsQueryRequestParams, OrganizationAdminsPathRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.organizations.admins(id), { params });
